import { getDocumentLanguage, getNavigatorLanguage, isValidLanguage, } from '@data/types/common';
import { isValidCurrency } from '@business/utils/currency';
export { decorateWithCrossDomainLinker } from './cross-domain-linker';
const languagePath = (lang) => lang && isValidLanguage(lang) ? `/${lang}` : '';
export const getLanguageForUrlPath = (lang) => {
    const documentLanguage = languagePath(getDocumentLanguage());
    if (lang === 'auto-detect') {
        const language = getNavigatorLanguage();
        return languagePath(language) || documentLanguage;
    }
    return languagePath(lang) || documentLanguage || '';
};
const getCurrencyForUrlPath = (currency) => currency && isValidCurrency(currency) ? `currency=${currency}` : '';
const getWindowSearchParams = () => { var _a; return ((_a = window.location.search.split('?')[1]) === null || _a === void 0 ? void 0 : _a.trim()) || ''; };
export const getSearchForUrlPath = (currency, ignoreSearchParams) => {
    const search = [
        getCurrencyForUrlPath(currency),
        ignoreSearchParams ? '' : getWindowSearchParams(),
    ].filter(Boolean);
    if (search.length === 0) {
        return '';
    }
    return `?${search.join('&')}`;
};
export const getInitialLocation = ({ language, propertyCode, search, }) => `${language}/reservation/${propertyCode}${search}`;
const NAME_PREFIX = 'data-property-name-';
const URL_PREFIX = 'data-property-url-';
export const parsePropertyDataFromElement = (element) => {
    const propertyNames = {};
    const propertyUrls = {};
    // Pass 1: Extract all property names (normalized to lowercase keys for O(1) lookups)
    for (const attr of element.attributes) {
        if (attr.name.startsWith(NAME_PREFIX)) {
            const code = attr.name.slice(NAME_PREFIX.length);
            if (code)
                propertyNames[code.toLowerCase()] = attr.value;
        }
    }
    // Pass 2: Extract all property URLs (normalized to lowercase keys for O(1) lookups)
    for (const attr of element.attributes) {
        if (attr.name.startsWith(URL_PREFIX)) {
            const code = attr.name.slice(URL_PREFIX.length);
            if (code)
                propertyUrls[code.toLowerCase()] = attr.value;
        }
    }
    return { propertyNames, propertyUrls };
};
/**
 * O(1) lookup by property code. Expects record keys to be normalized (lowercase).
 * parsePropertyDataFromElement returns normalized records.
 */
export const getPropertyCodeValue = (record, code) => record[code.toLowerCase()];
/**
 * Parses property-order string in semicolon-separated format.
 * Example: '2SI0CT;O2YXd0' → ['2SI0CT', 'O2YXd0']
 */
export const parsePropertyOrder = (value) => {
    const trimmed = value.trim();
    if (!trimmed)
        return undefined;
    return trimmed
        .split(';')
        .map((s) => s.trim())
        .filter(Boolean);
};
